import React, { useState } from "react";
import styled from "styled-components";
import { Layout } from "./ui/Layout";
import { SectionFeaturesList } from "./SectionFeaturesList";
import { mediaQuery } from "react-styled-mediaquery";
import { SectionFeaturesAndMore } from "./SectionFeaturesAndMore";
import { colors } from "../lib/constant";
import { CardDevices } from "./ui/CardDevices";

const Container = styled.div`
  margin-top: 100px;

  ${mediaQuery("<=", "desktop")`
      margin-top: 40px;
  `}
`;

const SeparededLine = styled.div`
  border-top: 1px solid ${colors.greyLt};
  height: 1px;
  width: 100%;
`;

interface IFeatureItem {
  label: React.ReactNode;
  desc?: React.ReactNode;
  imageUrl?: any;
}

export const SectionFeatures = ({ items }: { items: IFeatureItem[] }) => {
  const [activeElementIndex, setActiveElementIndex] = useState(0);

  return (
    <>
      <Layout>
        <CardDevices />

        <SectionFeaturesList
          onItemClick={(index) => setActiveElementIndex(index)}
          items={items.map((item, index) => ({
            ...item,
            active: activeElementIndex === index,
          }))}
        />

        <Container>
          <SectionFeaturesAndMore />
        </Container>

        <Container>
          <SeparededLine />
        </Container>
      </Layout>
    </>
  );
};
